import { IS_DEBUG_MODE_ENABLED } from '@/constants';

type LoggerArgs = unknown[];

const logger = {
  warn: (...args: LoggerArgs) =>
    console.log('%c [ITS WARN]', 'color: goldenrod;', ...args),
  error: (...args: LoggerArgs) =>
    console.log('%c [ITS ERROR]', 'color: crimson;', ...args),
  core: (...args: LoggerArgs) =>
    console.log('%c [ITS CORE]', 'color: steelblue;', ...args),
  info: (...args: LoggerArgs) =>
    console.log('%c [ITS INFO]', 'color: springgreen;', ...args),
};

type LogLabel = string;
type LogDebugObj = Record<string, unknown>;

interface PrintFn {
  logger: (...args: LoggerArgs) => void;
  debugMode: boolean;
  label: LogLabel;
  debugObj?: LogDebugObj;
}

const print = ({ debugMode, logger, label, debugObj }: PrintFn) => {
  logger(label);

  if (debugMode && debugObj) {
    for (const key in debugObj) {
      logger(`-- ${key}`, debugObj[key]);
    }
  }
};

interface CreateLogger {
  debugMode: boolean;
}

const createLogger = ({ debugMode }: CreateLogger) => {
  return {
    error: (label: LogLabel, debugObj?: LogDebugObj) =>
      print({ logger: logger.error, label, debugObj, debugMode }),
    warn: (label: LogLabel, debugObj?: LogDebugObj) =>
      print({ logger: logger.warn, label, debugObj, debugMode }),
    core: (label: LogLabel, debugObj?: LogDebugObj) =>
      print({ logger: logger.core, label, debugObj, debugMode }),
    info: (label: LogLabel, debugObj?: LogDebugObj) =>
      print({ logger: logger.info, label, debugObj, debugMode }),
  };
};

export const log = createLogger({ debugMode: IS_DEBUG_MODE_ENABLED });
